'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UserMenu = exports.ENGAGEMENT_ELEMENTS = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _tracking = require('@spp/tracking');

var _uiInternalLink = require('@spp/ui-internal-link');

var _uiInternalLink2 = _interopRequireDefault(_uiInternalLink);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _LoggedInBadge = require('../LoggedInBadge');

var _LoggedInBadge2 = _interopRequireDefault(_LoggedInBadge);

var _props = require('../props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_LOGIN_LABEL = 'Login'; /* eslint-disable import/no-named-as-default */

var DEFAULT_LOGOUT_LABEL = 'Logout';
var DEFAULT_MY_SUBSCRIPTION_LABEL = 'My Subscription';
var DEFAULT_MY_ACCOUNT_LABEL = 'My Account';

var ENGAGEMENT_ELEMENTS = exports.ENGAGEMENT_ELEMENTS = {
    MENU_MYSITE: 'MainMenu_MySite',
    MENU_BENEFITS: 'MainMenu_Benefits',
    MENU_READINGS: 'MainMenu_Readings',
    MENU_SUBSCRIBE: 'MainMenu_Subscribe',
    MENU_LOGIN: 'MainMenu_Login'
};

var engagementClickEvent = function engagementClickEvent(item, engagement) {
    return function (event) {
        event.preventDefault();

        _tracking.util.actionThenRelocateWithTimeout(engagement({
            elementIdentifier: item.event,
            meta: { name: item.name, event: event }
        }), item.url);
    };
};

var UserMenu = exports.UserMenu = function (_Component) {
    (0, _inherits3.default)(UserMenu, _Component);

    function UserMenu() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, UserMenu);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = UserMenu.__proto__ || (0, _getPrototypeOf2.default)(UserMenu)).call.apply(_ref, [this].concat(args))), _this), _this.innerMenuItems = function (_ref2) {
            var mySite = _ref2.mySite,
                readings = _ref2.readings,
                benefits = _ref2.benefits;
            var loggedIn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var mySiteItem = mySite ? (0, _extends3.default)({}, mySite, { event: ENGAGEMENT_ELEMENTS.MENU_MYSITE }) : null;
            var readingsItem = readings && loggedIn ? (0, _extends3.default)({}, readings, { event: ENGAGEMENT_ELEMENTS.MENU_READINGS }) : null;
            var benefitsItem = benefits ? (0, _extends3.default)({}, benefits, { event: ENGAGEMENT_ELEMENTS.MENU_BENEFITS }) : null;
            return [mySiteItem, readingsItem, benefitsItem].filter(Boolean);
        }, _this.renderInnerUserMenu = function (_ref3, items) {
            var theme = _ref3.theme,
                engagement = _ref3.engagement;
            return _react2.default.createElement(
                'ul',
                { className: theme.userMenuInner },
                items.map(function (item) {
                    return _react2.default.createElement(
                        'li',
                        { key: item.name, className: theme.userItem },
                        _react2.default.createElement(
                            _uiInternalLink2.default,
                            {
                                className: theme.userLink,
                                link: item.url,
                                onClick: engagementClickEvent(item, engagement),
                                enableSinglePage: true
                            },
                            item.name
                        )
                    );
                })
            );
        }, _this.renderLogin = function (_ref4) {
            var theme = _ref4.theme,
                spid = _ref4.spid,
                userMenu = _ref4.userMenu;
            var _userMenu$widgets = userMenu.widgets,
                widgets = _userMenu$widgets === undefined ? {} : _userMenu$widgets;
            var _widgets$LoginWidget = widgets.LoginWidget,
                LoginWidget = _widgets$LoginWidget === undefined ? null : _widgets$LoginWidget;
            var login = spid.login;

            // if login URL not yet available, do not render login control

            if (!login) {
                return null;
            }

            return LoginWidget !== null ? _this.renderLoginWidget(theme, spid, LoginWidget) : _this.renderLoginButton(_this.props, login);
        }, _this.renderLoginWidget = function (theme, spid, LoginWidget) {
            return _react2.default.createElement(LoginWidget, { theme: theme, spid: spid });
        }, _this.renderLoginButton = function (_ref5, login) {
            var theme = _ref5.theme,
                engagement = _ref5.engagement,
                userMenu = _ref5.userMenu;
            var _userMenu$labels = userMenu.labels,
                labels = _userMenu$labels === undefined ? {} : _userMenu$labels;
            var _labels$login = labels.login,
                loginLabel = _labels$login === undefined ? DEFAULT_LOGIN_LABEL : _labels$login;


            var engagementEvent = {
                name: 'Login',
                event: ENGAGEMENT_ELEMENTS.MENU_LOGIN
            };

            return _react2.default.createElement(
                'div',
                { className: theme.loginButtonWrapper },
                _react2.default.createElement(
                    'button',
                    {
                        className: theme.loginButton,
                        onClick: function onClick() {
                            _promise2.default.race([engagementClickEvent(engagementEvent, engagement), new _promise2.default(function (resolve) {
                                return setTimeout(resolve, 1000);
                            })]).then(login);
                        }
                    },
                    loginLabel
                )
            );
        }, _this.renderLoggedInMenu = function (_ref6) {
            var theme = _ref6.theme,
                spid = _ref6.spid,
                userLoggedInSvg = _ref6.userLoggedInSvg,
                userMenu = _ref6.userMenu,
                engagement = _ref6.engagement,
                attributes = _ref6.attributes;
            var _userMenu$labels2 = userMenu.labels,
                labels = _userMenu$labels2 === undefined ? {} : _userMenu$labels2;
            var _labels$logout = labels.logout,
                logout = _labels$logout === undefined ? DEFAULT_LOGOUT_LABEL : _labels$logout,
                _labels$mySubscriptio = labels.mySubscription,
                mySubscription = _labels$mySubscriptio === undefined ? DEFAULT_MY_SUBSCRIPTION_LABEL : _labels$mySubscriptio,
                _labels$myAccount = labels.myAccount,
                myAccount = _labels$myAccount === undefined ? DEFAULT_MY_ACCOUNT_LABEL : _labels$myAccount;
            var _userMenu$widgets2 = userMenu.widgets,
                widgets = _userMenu$widgets2 === undefined ? {} : _userMenu$widgets2;
            var _widgets$LoggedInWidg = widgets.LoggedInWidget,
                LoggedInWidget = _widgets$LoggedInWidg === undefined ? false : _widgets$LoggedInWidg;


            var loggedInProps = {
                theme: theme,
                spid: spid,
                myPage: userMenu.myPage,
                userLoggedInSvg: userLoggedInSvg,
                showLogoutButton: true,
                labels: { logout: logout, mySubscription: mySubscription, myAccount: myAccount },
                mastheadExtensionButton: 'login',
                engagement: engagement,
                attributes: attributes
            };

            if (!LoggedInWidget) {
                LoggedInWidget = _LoggedInBadge2.default;
                loggedInProps.placement = _LoggedInBadge2.default.IN_USER_MENU;
            }

            var loggedInItems = _this.innerMenuItems(userMenu, true);

            return _react2.default.createElement(
                'ul',
                { className: theme.userMenu, 'aria-label': 'user menu' },
                _react2.default.createElement(
                    'li',
                    { className: theme.userDetails },
                    _react2.default.createElement(LoggedInWidget, loggedInProps)
                ),
                _this.renderUserMenu(_this.props, loggedInItems)
            );
        }, _this.renderLoggedOutMenu = function (_ref7) {
            var theme = _ref7.theme,
                userMenu = _ref7.userMenu,
                engagement = _ref7.engagement;
            var loginFirst = userMenu.loginFirst;

            var Login = _this.renderLogin(_this.props);

            var engagementEvent = {
                name: 'Subscribe',
                url: userMenu.subscribe.url,
                event: ENGAGEMENT_ELEMENTS.MENU_SUBSCRIBE
            };

            var anchorProps = {
                className: theme.subscribeButton,
                link: userMenu.subscribe.url,
                enableSinglePage: true,
                onClick: engagementClickEvent(engagementEvent, engagement)
            };

            var loggedOutItems = _this.innerMenuItems(userMenu, false);
            var showUserMenu = loggedOutItems.length > 0;

            return _react2.default.createElement(
                'div',
                { className: theme.temp },
                _react2.default.createElement(
                    'div',
                    { className: theme.userMenuButtons },
                    loginFirst && Login,
                    _react2.default.createElement(
                        'div',
                        { className: theme.subscribeButtonWrapper },
                        _react2.default.createElement(
                            _uiInternalLink2.default,
                            anchorProps,
                            userMenu.subscribe.name
                        )
                    ),
                    !loginFirst && Login
                ),
                showUserMenu ? _react2.default.createElement(
                    'ul',
                    { className: theme.userMenu, 'aria-label': 'user menu' },
                    _this.renderUserMenu(_this.props, loggedOutItems)
                ) : null
            );
        }, _this.renderUserMenu = function (_ref8, items) {
            var userMenu = _ref8.userMenu,
                theme = _ref8.theme,
                spid = _ref8.spid,
                engagement = _ref8.engagement,
                attributes = _ref8.attributes;
            var _userMenu$widgets3 = userMenu.widgets,
                widgets = _userMenu$widgets3 === undefined ? {} : _userMenu$widgets3;
            var _widgets$UserMenuWidg = widgets.UserMenuWidget,
                UserMenuWidget = _widgets$UserMenuWidg === undefined ? null : _widgets$UserMenuWidg;

            var UserMenuWidgetProps = { theme: theme, spid: spid, userMenu: userMenu, engagement: engagement, attributes: attributes };

            return _react2.default.createElement(
                'li',
                null,
                UserMenuWidget ? _react2.default.createElement(UserMenuWidget, UserMenuWidgetProps) : null,
                items.length > 0 ? _this.renderInnerUserMenu(_this.props, items) : null
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(UserMenu, [{
        key: 'render',
        value: function render() {
            var _props$spid = this.props.spid,
                spid = _props$spid === undefined ? {} : _props$spid;
            var _spid$loggedIn = spid.loggedIn,
                loggedIn = _spid$loggedIn === undefined ? false : _spid$loggedIn;


            return loggedIn ? this.renderLoggedInMenu(this.props) : this.renderLoggedOutMenu(this.props);
        }
    }]);
    return UserMenu;
}(_react.Component);
/* eslint-disable react/no-unused-prop-types */


var userMenuPropTypes = {
    engagement: _propTypes2.default.func,
    attributes: _propTypes2.default.func,
    spid: _propTypes2.default.shape({
        login: _propTypes2.default.func,
        loggedIn: _propTypes2.default.bool.isRequired,
        givenName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(null)]),
        familyName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(null)])
    }).isRequired,
    userMenu: _propTypes2.default.shape(_props.userMenuProps).isRequired,
    userLoggedInSvg: _propTypes2.default.shape(_props.svgProps).isRequired,
    theme: _propTypes2.default.shape({
        userMenu: _propTypes2.default.string,
        userMenuInner: _propTypes2.default.string,
        userData: _propTypes2.default.string,
        userDetails: _propTypes2.default.string,
        loginButton: _propTypes2.default.string,
        userButton: _propTypes2.default.string,
        userButtonWrapper: _propTypes2.default.string,
        userButtonWrapperMobileOnly: _propTypes2.default.string,
        userItem: _propTypes2.default.string,
        userLink: _propTypes2.default.string
    })
};
/* eslint-enable react/no-unused-prop-types */

if (process.env.NODE_ENV !== 'production') {
    UserMenu.propTypes = userMenuPropTypes;
}

UserMenu.defaultProps = {
    attributes: function attributes() {},
    engagement: function engagement() {
        return _promise2.default.resolve();
    },
    theme: {}
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        spid: state.spid
    };
})(UserMenu);
//# sourceMappingURL=UserMenu.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/UserMenu/UserMenu.js
 ** module id = 335
 ** module chunks = 0
 **/